import { render } from "./AgentCategoryShareView.vue?vue&type=template&id=45402946&scoped=true"
import script from "./AgentCategoryShareView.vue?vue&type=script&lang=js"
export * from "./AgentCategoryShareView.vue?vue&type=script&lang=js"

import "./AgentCategoryShareView.vue?vue&type=style&index=0&id=45402946&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45402946"]])

export default __exports__